import type { Follow } from '../../../types/following';
import { RaceStatus } from '../../../config/types';

const anyInProgress = (follows: Follow[]): boolean =>
  follows.some(
    (follow) =>
      follow.predictionsData?.raceStatus === RaceStatus.Starting ||
      follow.predictionsData?.raceStatus === RaceStatus.InProgress
  );

export default anyInProgress;
